// Structured Data for SEO, AEO, and GEO optimization

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Infinite Reyn Productions",
  "description": "A multi-disciplinary creative house built for stories that refuse to stay in one form. Books. Music. Theatre. One source.",
  "url": typeof window !== 'undefined' ? window.location.origin : '',
  "logo": "/images/hero/main-hero.jpg",
  "founder": {
    "@type": "Person",
    "name": "Infinite Reyn Productions"
  },
  "foundingDate": "2025",
  "sameAs": [
    // Add social media URLs when available
  ],
  "knowsAbout": [
    "Books",
    "Music",
    "Theatre",
    "Paranormal Romance",
    "Worship Music",
    "Creative Writing",
    "Performance Arts"
  ]
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Infinite Reyn Productions",
  "description": "Where Stories Take Form - Books, Music, Theatre",
  "url": typeof window !== 'undefined' ? window.location.origin : '',
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": typeof window !== 'undefined' ? `${window.location.origin}/blog?search={search_term_string}` : ''
    },
    "query-input": "required name=search_term_string"
  }
};

export const musicAlbumSchema = (album) => ({
  "@context": "https://schema.org",
  "@type": "MusicAlbum",
  "name": album.title,
  "byArtist": {
    "@type": "MusicGroup",
    "name": album.artist
  },
  "image": album.image,
  "description": album.fullDescription,
  "datePublished": album.releaseDate,
  "genre": "Worship Music",
  "inLanguage": ["en", "es"],
  "numTracks": album.tracks ? album.tracks.length : 0,
  "track": album.tracks ? album.tracks.map((track, index) => ({
    "@type": "MusicRecording",
    "name": track,
    "position": index + 1
  })) : []
});

export const bookSchema = (book) => ({
  "@context": "https://schema.org",
  "@type": "Book",
  "name": book.title,
  "author": {
    "@type": "Person",
    "name": book.author
  },
  "image": book.image,
  "description": book.fullDescription,
  "genre": "Paranormal Romance",
  "bookFormat": "https://schema.org/EBook",
  "inLanguage": "en",
  "datePublished": book.releaseDate,
  "publisher": {
    "@type": "Organization",
    "name": "Infinite Reyn Productions"
  }
});

export const theaterEventSchema = (event) => ({
  "@context": "https://schema.org",
  "@type": "TheaterEvent",
  "name": event.title,
  "description": event.fullDescription,
  "image": event.image,
  "organizer": {
    "@type": "Organization",
    "name": "Infinite Reyn Productions"
  },
  "eventStatus": "https://schema.org/EventScheduled",
  "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode"
});

export const blogPostSchema = (post) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "headline": post.title,
  "image": post.image,
  "author": {
    "@type": "Person",
    "name": post.author
  },
  "publisher": {
    "@type": "Organization",
    "name": "Infinite Reyn Productions",
    "logo": {
      "@type": "ImageObject",
      "url": "/images/hero/main-hero.jpg"
    }
  },
  "datePublished": post.date,
  "description": post.excerpt,
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": typeof window !== 'undefined' ? `${window.location.origin}/blog/${post.id}` : ''
  }
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

// FAQ Schema for AEO optimization
export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});
